import React from "react";
import { Card, CardContent } from "../components/ui/card";
import Calculators from "../components/Calculators";

export default function CalculatorsPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <p className="overline text-xs uppercase tracking-[0.2em] font-bold text-primary">Tools</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-2">Financial Calculators</h1>
      <p className="text-base md:text-lg text-muted-foreground mt-4 max-w-3xl">
        Explore SIP, Lumpsum, EMI, Retirement, Goal, Inflation, Bond Yield and more — fully interactive, instantly calculated.
      </p>
      <div className="mt-10">
        <Calculators />
      </div>
      <Card className="mt-10 bg-accent/40 border-primary/30">
        <CardContent className="p-6 text-xs text-muted-foreground italic">
          All calculator outputs are approximations based on the inputs provided and assumed compounding. They are not investment advice. Mutual fund investments are subject to market risks. Read all scheme-related documents carefully.
        </CardContent>
      </Card>
    </div>
  );
}
